
function TimersController($scope, $window, orderByFilter) {
    var ctrl = this;

    this.$onInit = function () {
        //console.log('onInit');        
        //ctrl.sortTimers();
    };
    
    this.$onChanges = function (changes) {
        //console.log('onChanges');        
        //console.log(changes);
        if (changes) {
            ctrl.sortTimers();
        }
        
    };


    ctrl.addTimer = function () {
        if (!ctrl.timers) {
            ctrl.timers = [];
        }
        ctrl.timers.push({
            TimerMonday: true, TimerTuesday: true, TimerWednesday: true, TimerThursday: true, TimerFriday: true,
            RowState: 'New'
        });

        //console.log('addTimer');
        ctrl.editing = true;
    };

    ctrl.removeTimer = function ($index) {
        ctrl.timers.splice($index, 1);
    };

    ctrl.edit = function () {
        ctrl.editing = true;
    };

    ctrl.clearEmpty = function () {
        var hasEmpty = true;
        while (hasEmpty) {
            hasEmpty = false;
            for (var i = 0; i < ctrl.timers.length; i++) {
                var timer = ctrl.timers[i];
                if (!timer.Hour && !timer.Minute) {
                    ctrl.removeTimer(i);
                    hasEmpty = true;
                    break;
                }
                else {
                    if (!timer.Minute) {
                        timer.Minute = 0;
                    }
                }
            }
        }        
    };

    ctrl.sortTimers = function () {
        if (ctrl.timers) {
            var sorted = orderByFilter(ctrl.timers, ['Hour', 'Minute']);
            //transfere para mesmo array para nao perder o one-way binding
            for (var i = 0; i < ctrl.timers.length; i++) {
                ctrl.timers[i] = sorted[i];
            }
        }
    };

    ctrl.save = function () {
        ctrl.sortTimers();
        
        ctrl.clearEmpty();
        ctrl.editing = false;
    };

    ctrl.cancel = function () {
        ctrl.clearEmpty();
        ctrl.editing = false;
    };    

    ctrl.fillZeros = function (number) {
        if (ctrl.isNumber(number)) {
            var str = ("0" + number).slice(-2);
            return str;
        }
        else {
            return number;
        }
    };

    ctrl.hasTimers = function () {
        if (ctrl.timers) {
            return ctrl.timers.length > 0;
        }
        else {
            return false;
        }
    };

    ctrl.isNumber = function (value) {
        return typeof value === 'number' && isFinite(value);
    };

    ctrl.allOff = function (timer) {
        return !(timer.TimerMonday || timer.TimerTuesday || timer.TimerWednesday || timer.TimerThursday || timer.TimerFriday || timer.TimerSaturday || timer.TimerSunday);
    };
}


seedWebApp.component('integrationTimers', {
    controller: TimersController,
    bindings: {
        timers: '<',
        readOnly: '<',
        size: '@'
    },
    templateUrl: './SPA/Integrations/integrationTimers.html'
});


